import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useHistory } from 'react-router-dom';

interface ErrorMessageProps {
  mainCopy?: React.ReactNode;
  specificError?: string;
}

/**
 * ErrorMessage displays an error message with instructions to contact support.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {React.ReactNode} [props.mainCopy] - Error main copy
 * @param {string} [props.specificError] - More precise error from API response
 * @example
 * return (
 *   <ErrorMessage />
 * )
 */
const ErrorMessage: React.FC<ErrorMessageProps> = ({ mainCopy, specificError }) => {
    const history = useHistory();
    const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'mariano@kwadhub.com';
    const defaultMainCopy = (
        <>
      If the problem persists, please contact support through the{' '}
            <Link
                component="button"
                variant="body2"
                underline="hover"
                onClick={() => history.push('/contact-us')}
                sx={{
                    fontSize: '1rem',
                }}
            >
        Contact us
            </Link>{' '}
      option or send an email to{' '}
            <Link href={`mailto:${supportEmail}`} underline="hover">
                {supportEmail}
            </Link>
      .
        </>
    );

    return (
        <Box>
            {specificError && (
                <Typography color="error" gutterBottom>
                    {specificError}
                </Typography>
            )}
            <Typography>{mainCopy || defaultMainCopy}</Typography>
        </Box>
    );
};

export default ErrorMessage;
